import { forwardRef } from 'react';

export const EsclamationIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="10" cy="10" r="10" fill="#004B54" />
        <path d="M9 14.5H11V8.5H10H9V14.5Z" fill="white" />
        <path
          d="M8.9212 6.50228C8.9212 6.21554 9.01887 5.97808 9.21421 5.78991C9.40954 5.59726 9.67148 5.50093 10 5.50093C10.3241 5.50093 10.5838 5.59726 10.7791 5.78991C10.9789 5.97808 11.0788 6.21554 11.0788 6.50228C11.0788 6.78006 10.9789 7.01527 10.7791 7.20792C10.5838 7.40057 10.3241 7.4969 10 7.4969C9.67148 7.4969 9.40954 7.40057 9.21421 7.20792C9.01887 7.01527 8.9212 6.78006 8.9212 6.50228Z"
          fill="white"
        />
      </svg>
    );
  },
);
